var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-total-edit-content-wrapper",
    {
      attrs: { value: _vm.currentTab },
      on: {
        input: function ($event) {
          return _vm.$emit("update:currentTab", $event)
        },
      },
    },
    [
      _c(
        "w-sortable",
        {
          attrs: {
            items: _vm.value.Conditions,
            tag: "w-list",
            "target-class": "handle",
            "disable-x": "",
            "keep-in-y": "",
          },
        },
        _vm._l(_vm.value.Conditions, function (condition, i) {
          return _c("app-total-edit-condition-item", {
            key: condition.key,
            attrs: {
              condition: condition,
              "is-editing": _vm.toEditCondition == condition,
            },
            on: {
              edit: function ($event) {
                return _vm.editCondition(i)
              },
              remove: function ($event) {
                return _vm.removeCondition(i)
              },
            },
          })
        }),
        1
      ),
      _c(
        "w-list-item",
        {
          on: {
            click: function ($event) {
              return _vm.addCondition()
            },
          },
        },
        [
          _c("w-list-item-icon", [_c("w-fa", { attrs: { icon: "plus" } })], 1),
          _c("w-list-item-text", [_vm._v(_vm._s(_vm.$ct("add-condition")))]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }